export default "__VITE_ASSET__0PI5fpmk__"